import TYPES from "@/core/services/Changelogs/types";
export type CustomResolver = (oldValue: any, newValue: any) => any;
type type = typeof TYPES[keyof typeof TYPES];
export type FieldDescriptor = {
    title: string;
    type: type;
    resolver?: CustomResolver;
}

function Title_ru_RU(title: string, type: type, resolver?: CustomResolver) {
    return function (target: any, propertyKey: string) {
        if (!target.constructor._fieldDescriptors) {
            target.constructor._fieldDescriptors = {};
        }

        const innerKey = propertyKey.substring(0, 1) === '_' ? propertyKey.slice(1) : propertyKey;

        target.constructor._fieldDescriptors[innerKey] = {
            title,
            type,
            resolver
        };
    };
}

export default Title_ru_RU;
